// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"StartButton_buttonsWrapper__D7zIo","button":"StartButton_button__rqEXY"};